import CreateIssueError from "./CreateIssueError";

export default class IssueRecordAlreadyExistsError extends CreateIssueError {

}